export default __webpack_public_path__ + "static/media/326.a14b39a0.png";